<script lang="ts">
    import CardModal from "../presentational/CardModal.svelte";
    import SemesterModal from "../presentational/SemesterModal.svelte";
    import ModuleModal from "../presentational/ModuleModal.svelte";

    export let data;
    export let manager;
    export let type;
    export let languages;
</script>

{#if $data !== null && $type !== null}
    {#if $type === 'card'}
        <CardModal languages={languages} subject={$data} manager={manager}/>
    {/if}
    {#if $type === 'semester'}
        <SemesterModal semester={$data}/>
    {/if}
    {#if $type === 'module'}
        <ModuleModal module={$data}/>
    {/if}
{/if}